import React from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import { ScreenClassRender } from "react-grid-system";
import cx from "clsx";

import Logo from "@/components/shared/logo";
import Footer from "@/components/footer";

import globalStyles from "@/styles/global.module.scss";
import styles from "./layout.module.scss";
import "@/styles/index.scss";

const Layout = props => {
  const {
    onGalleryClick,
    onFilmClick,
    className,
    hideLogo,
    isDesktop,
    screenClass,
    userIsTabbing,
    windowHeight,
    hideFooter,
    children
  } = props;

  return (
    <ParallaxProvider>
      <Logo
        hidden={hideLogo || !isDesktop}
        isDesktop={isDesktop}
        windowHeight={windowHeight}
      />

      <ScreenClassRender
        render={screenClass => <div className={screenClass} />}
      />

      <div
        className={cx(
          className,
          styles.container,
          userIsTabbing && globalStyles.userIsTabbing,
          userIsTabbing && "userIsTabbing",
          isDesktop && styles.desktop,
          !isDesktop && styles.mobile
        )}
      >
        {children}
      </div>

      {!hideFooter ? (
        <Footer
          isDesktop={isDesktop}
          screenClass={screenClass}
          userIsTabbing={userIsTabbing}
          onGalleryClick={onGalleryClick}
          onFilmClick={onFilmClick}
        />
      ) : null}
    </ParallaxProvider>
  );
};

export default Layout;
